import {
  Drawer,
  ListItemIcon,
  ListItemText,
  MenuItem,
} from "@material-ui/core";
import { FindInPage } from "@material-ui/icons";
import { useState } from "react";
import { Show } from "react-admin";
import { MasterEldDeviceDto } from "../../../common/data/service-proxies";
import { ShowEldMessageDetailsFields } from "./ShowEldMessageDetailsFields";

interface Props {
  record?: MasterEldDeviceDto;
  onClick?: () => void;
  basePath?: string;
  resource?: string;
}

export const ShowEldMessageDetailsMenuItem = ({
  record,
  onClick,
  basePath,
  resource,
}: Props) => {
  const [drawerOpen, setDrawerOpen] = useState<boolean>(false);
  return (
    <>
      <MenuItem
        className="actions-menu-item"
        onClick={(e) => {
          setDrawerOpen(true);
          if (onClick) {
            onClick();
          }
        }}
      >
        <ListItemIcon>
          <FindInPage />
        </ListItemIcon>
        <ListItemText>Show details</ListItemText>
      </MenuItem>
      <Drawer
        open={drawerOpen}
        anchor="right"
        onClose={() => setDrawerOpen(false)}
      >
        <div style={{ width: "600px" }}>
          {drawerOpen ? (
            <Show
              basePath={basePath}
              resource={resource}
              id={`${record?.id}`}
              title=" "
            >
              <ShowEldMessageDetailsFields />
            </Show>
          ) : null}
        </div>
      </Drawer>
    </>
  );
};
